import React from "react";
import { GlobeIcon, LockIcon, DownloadIcon, BanIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { Countdown } from "./Countdown";
import { ScarcityBar } from "./ScarcityBar";
type OfferBoxProps = {
  label: string;
  heading?: string;
  ctaId?: string;
  dark?: boolean;
};
export function OfferBox({
  label,
  heading,
  ctaId,
  dark = false
}: OfferBoxProps) {
  return <div className={`mx-auto w-full max-w-xl rounded-3xl p-5 sm:p-8 ${dark ? "bg-navy-800 ring-2 ring-electric-light/40" : "bg-white shadow-xl shadow-navy-900/10 ring-1 ring-navy-900/10"}`} data-id="element-40" data-mp="2cd86vogqe25k">
      {heading && <p className={`text-center font-display text-xl font-bold uppercase leading-tight sm:text-2xl ${dark ? "text-white" : "text-ink"}`} data-id="element-41" data-mp="23jlnkxtpmrd9">
          {heading}
        </p>}

      <div className="mt-2 flex items-end justify-center gap-3" data-id="element-42" data-mp="3032hdzdkvemn">
        <span className={`pb-3 font-display text-2xl font-semibold line-through ${dark ? "text-white/50" : "text-muted/70"}`} data-id="element-43" data-mp="305f6cwhr6p97">
          $180
        </span>
        <span className={`font-display text-8xl font-extrabold leading-none ${dark ? "text-cta" : "text-electric"}`} data-id="element-44" data-mp="30f83xz72caax">
          $27
        </span>
        <span className={`pb-3 font-display text-2xl font-bold ${dark ? "text-white" : "text-ink"}`} data-id="element-45" data-mp="3ae61tsqdpg6l">
          USD
        </span>
      </div>
      <p className={`mt-1 text-center text-sm font-bold uppercase tracking-wide ${dark ? "text-white/80" : "text-muted"}`} data-id="element-46" data-mp="3k5k3o75sys2w">
        One-time payment · Digital collection
      </p>

      <CTAButton id={ctaId} label={label} className="mt-5" data-id="element-47" data-mp="3t5p3nw8o2o71" />

      <div className="mt-6" data-id="element-48" data-mp="3t45n04j3mb4q">
        <Countdown dark={dark} data-id="element-49" data-mp="23qio0eezxrrl" />
      </div>

      <div className="mt-6" data-id="element-50" data-mp="23rag3f9dx7d4">
        <ScarcityBar dark={dark} data-id="element-51" data-mp="1yrxlg8c9uvzz" />
      </div>

      <div className={`mt-5 flex items-start gap-3 rounded-2xl p-3.5 text-sm ${dark ? "bg-white/10 text-white/90" : "bg-paper text-ink"}`} data-id="element-52" data-mp="1yt8y6xnp3e38">
        <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-electric-light" aria-hidden="true" data-id="element-53" data-mp="7n43317mum74" />
        <p data-id="element-54" data-mp="bozewzn6whz5">
          <strong data-id="element-55" data-mp="bofwlhtmnrkl">Automatic currency conversion.</strong> The $27 USD price is converted to your local
          currency automatically at checkout.
        </p>
      </div>

      <ul className={`mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1.5 text-xs font-medium ${dark ? "text-white/70" : "text-muted"}`} data-id="element-56" data-mp="lnwz5qdl1pcc">
        <li className="flex items-center gap-1" data-id="element-57" data-mp="qknhylgruz1g">
          <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-58" data-mp="vej9p66fzpo6" /> Secure checkout
        </li>
        <li className="flex items-center gap-1" data-id="element-59" data-mp="zfbla62se6nm">
          <DownloadIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-60" data-mp="zh649euhzop2" /> Digital product
        </li>
        <li className="flex items-center gap-1" data-id="element-61" data-mp="14c1zsoyy0u6x">
          <BanIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-62" data-mp="19cga6do0og84" /> No recurring subscription
        </li>
      </ul>
    </div>;
}